import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import GoogleButton from "@/components/GoogleButton";

export default function Register() {
  const { register, user, ready } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name:"", email:"", company:"", password:"" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [showEmail, setShowEmail] = useState(false);

  useEffect(() => {
    if (ready && user && user.id) nav("/quiz", { replace: true });
  }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    const r = await register(form);
    setLoading(false);
    if (r.ok) {
      toast.success("Registrazione completata");
      nav("/quiz");
    } else setErr(r.error || "Errore");
  };

  return (
    <section className="section-pad">
      <div className="max-w-md mx-auto px-6">
        <p className="eyebrow mb-4">Area riservata</p>
        <h1 className="font-display text-4xl text-[#2A3229] mb-2">Crea il tuo account</h1>
        <p className="text-[#5A6058] mb-10">Il modo più veloce per accedere al Check‑Up di Assetto Aziendale.</p>

        <GoogleButton label="Registrati con Google" testid="reg-google" />

        <div className="mt-8 flex items-center gap-4">
          <div className="flex-1 h-px bg-[#323C36]/15"/>
          <span className="text-xs uppercase tracking-widest text-[#5A6058]">oppure</span>
          <div className="flex-1 h-px bg-[#323C36]/15"/>
        </div>

        {!showEmail ? (
          <button
            data-testid="show-email-register"
            onClick={() => setShowEmail(true)}
            className="mt-8 w-full text-sm text-[#5A6058] hover:text-[#323C36] underline underline-offset-4"
          >
            Preferisco registrarmi con email
          </button>
        ) : (
          <form onSubmit={submit} data-testid="register-form" className="mt-8 space-y-6">
            <input data-testid="reg-name" required placeholder="Nome e cognome" className="field-input" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/>
            <input data-testid="reg-email" required type="email" placeholder="Email" className="field-input" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/>
            <input data-testid="reg-company" placeholder="Azienda (facoltativo)" className="field-input" value={form.company} onChange={e=>setForm({...form,company:e.target.value})}/>
            <input data-testid="reg-password" required type="password" placeholder="Password (min. 6 caratteri)" className="field-input" value={form.password} onChange={e=>setForm({...form,password:e.target.value})}/>
            {err && <p data-testid="reg-error" className="text-sm text-[#A8674F]">{err}</p>}
            <button data-testid="reg-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">{loading ? "Creazione…" : "Crea account"}</button>
            <p className="text-sm text-[#5A6058] text-center">Hai già un account? <Link to="/login" className="text-[#323C36] underline" data-testid="to-login">Accedi</Link></p>
          </form>
        )}
      </div>
    </section>
  );
}
